import { useSuspenseQuery } from '@apollo/client';
import { useIntl } from 'react-intl';

import { CompaniesIndustriesDocument } from '../../graphql/queries/companies-industries.gql-types';

export const DEFAULT_ORDER = 'TOTAL';
const OTHER_INDUSTRIES_KEY = 'INDUSTRY_230000';

type CompaniesIndustriesProps = {
  limit?: number;
};

export const useCompaniesIndustries = ({
  limit = 23,
}: CompaniesIndustriesProps = {}) => {
  const { error, ...rest } = useSuspenseQuery(CompaniesIndustriesDocument, {
    variables: {
      limit,
      order: DEFAULT_ORDER,
    },
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export const useAllIndustries = () => {
  const intl = useIntl();
  const { data, ...rest } = useCompaniesIndustries();
  const industries = data?.companiesIndustries?.collection;
  const otherIndustry = industries?.filter(
    (item) => item?.industry?.localizationKey === OTHER_INDUSTRIES_KEY
  );
  const restIndustries = industries
    ?.filter((item) => item?.industry?.localizationKey !== OTHER_INDUSTRIES_KEY)
    .sort((current, next) => {
      const currentValue =
        intl.$t({ id: current?.industry?.localizationKey }) ?? '';
      const nextValue = intl.$t({ id: next?.industry?.localizationKey }) ?? '';
      return currentValue.localeCompare(nextValue);
    });
  const orderedIndustries = [
    ...(restIndustries ?? []),
    ...(otherIndustry ?? []),
  ];

  return {
    orderedIndustries,
    ...rest,
  };
};
